import React from "react";
import Group181 from "../Group181";
import "./Web1920137.css";

function Web1920137(props) {
  const { overlapGroup } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-137 screen">
        <div className="overlap-group-51" style={{ backgroundImage: `url(${overlapGroup})` }}>
          <Group181 />
        </div>
      </div>
    </div>
  );
}

export default Web1920137;
